import React, {useState} from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";

import ExpandInfo from "./ExpandInfo";


const Pas8 = () => {

  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? "20px" : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -60 : "50px",
        }}
      >
       {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "32rem" : "26rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
         <div style={{ marginLeft: isMobile ? 10 : 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              DEER
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Procesul-verbal de recepție a punerii în funcțiune a instalațiilor
            de producere și, după caz, a instalației de stocare
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            După finalizarea perioadei de probe
          </Typography>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Emiterea certificatului de racordare
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            (După depunerea dosarului instalației de utilizare și finalizarea
            lucrărilor de racordare, vom emite Certificatul de Racordare al
            locului de consum.Certificatul de racordare este unul din
            documentele care stă la baza încheierii contractului de furnizare a
            energiei electrice.)
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
          3 zile lucrătoare de la data depunerii procesului-verbal de recepție a punerii în funcțiune a instalațiilor de producere
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "46rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{ height: "4rem", width: "4px", backgroundColor: "#29348f" }}
        />
<ExpandInfo/>

      </div>
    </div>
  );
};
export default Pas8;
